import React from "react";
import { useSelector } from "react-redux";

import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";

import { userCompanySelector } from "src/store/system/selector";
import { updateCompanyInformation } from "src/apiService/modules/system";
import { ImageInputComponent, ClearSymbol } from "src/components/ImageInput";
import { useRecordEvent } from "src/hooks/useRecordEvent";

function CompanyInfo() {
  const recordEvent = useRecordEvent();

  const company = useSelector(userCompanySelector);
  return (
    <Box display="flex" flexDirection="column">
      <TextField
        defaultValue={company?.name || ""}
        onBlur={(ev) => {
          const name = ev.target.value || "";
          updateCompanyInformation({ name });
        }}
        margin="dense"
        label="Company Name"
        name="name"
        fullWidth
        variant="outlined"
        required
        autoComplete="off"
      />
      <FormControl margin="dense" variant="outlined" fullWidth>
        <InputLabel variant="outlined">Company Logo</InputLabel>
        <OutlinedInput
          fullWidth
          margin="dense"
          label="Company Logo"
          inputComponent={ImageInputComponent}
          onChange={(ev) => {
            const isRemove = !ev.target.value || (ev.target.value as any) === ClearSymbol;
            updateCompanyInformation({
              logo: isRemove ? undefined : ev.target.value,
            });
            recordEvent({
              type: "feature-adoption",
              feature: "logo-upload",
              element: "company-info",
              action: isRemove ? "remove" : "upload",
            });
          }}
          defaultValue={company?.logo}
        />
      </FormControl>
    </Box>
  );
}

export default CompanyInfo;
